// extracted by mini-css-extract-plugin
export default {"wizardTable":"style_wizardTable__bMVWt","fontSize11px":"style_fontSize11px__VxbuX"};